import { MARKETPLACE } from "@acc/shared"
import BaseApi from "../api/api"
import { ISupply } from "../app/reducers/ordersReducer"

export const loadAuditFormOrder = async (
  shop: string,
  marketplace?: string,
  values?: string[],
): Promise<any[]> => {
  const res = await Promise.all(
    values?.map((value) => {
      return BaseApi.auditFormOrderFile(
        shop,
        marketplace,
        "FORM_ORDER_FILE",
        value,
      )
    }) || [],
  )

  return res.map((item) => item.data)
}

export const saveAuditFormOrderWB = async (
  shop: string,
  supplies: ISupply[],
): Promise<void> => {
  if (supplies.length) {
    BaseApi.putAuditFormOrderFile(
      supplies.map((supp) => ({
        shop,
        marketplace: MARKETPLACE.WB,
        type: "FORM_ORDER_FILE",
        value: supp.id,
      })),
    )
  }
}
